export default "__VITE_ASSET__CHVwAO9L__"